import { Component, OnInit } from '@angular/core';
import { MainService } from 'src/app/services/main/main.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {

  constructor(
    // tslint:disable-next-line:variable-name
    public _mainService: MainService
  ) { }

  ngOnInit() {
  }

}
